// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "https://user-images.githubusercontent.com/101293824/193792227-8f53a303-d827-45ea-8a08-8bffc402ad22.png",
    title: "Milaap Clone",
    description: "This project is about building a web application to donate and lend money to the needy ones. It have some cool features like save the data in redux-store and loacl-storage to reduce the dependency of network requests",
    tech_stack: "React.js, Redux, javascript,  ChakraUI.",
    github_url: "https://github.com/Manya7864/greasy-sofa-2441",
    demo_url: "https://milaap.vercel.app/",
  },
  {
    img: "https://camo.githubusercontent.com/ca81d83e4cd585cb9fb1a02abff8aec084bd18b424218cf7ee1cfba6ade97b16/68747470733a2f2f6d69726f2e6d656469756d2e636f6d2f6d61782f3837352f312a4661766355635047774d32573864737a4737446e2d672e706e67",
    title: "NordStorm Clone",
    description:
      "Nordstrom is an American luxury department store chain headquartered in Seattle, Washington and founded by John W. Nordstrom and Carl F. Wallin in 1901. They sell various products, like cosmetics, skincare, body care, clothing, home decors etc",
    tech_stack: "HTML, CSS, Javascript,ES6",
    github_url: "https://github.com/Manya7864/Unit3_NordStrom",
    demo_url: "https://glittering-tulumba-05584d.netlify.app/",
  },
  
  {
    img: "https://user-images.githubusercontent.com/43124877/162619979-6215f2b1-9a02-4033-8dd2-ac4b63e1a091.png",
    title: "MonsterIndia Clone",
    description: "MonsterIndia is a global online employment solution for people seeking jobs and the employers who need great people Replicated most of the major features of website.",
    tech_stack: "HTML, CSS, Javascript",
    github_url: "https://github.com/Manya7864/MonsterindiaClone",
    demo_url: "https://spiffy-cactus-59b8fe.netlify.app/",
  },
];






export const stackList = [
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/html5.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/css3.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/javascript.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/react.svg",
    name: "ReactJS",
  },
  {
    img:"https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
    name: "Redux",
  },
  
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    name: "TypeScript",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/bootstrap.svg",
    name: "Bootstrap",
  },
  {
    img: "https://pbs.twimg.com/profile_images/1244925541448286208/rzylUjaf_400x400.jpg",
    name: "Chakra Ui",
  },
  // {
  //   img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/sass.svg",
  //   name: "Scss",
  // },
  
  
  // {
  //   img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/responsive.svg",
  //   name: "Responsive",
  // },
];

export const Soft=[
  {
  title:"Teamwork|"
},
{
  title:"Adaptability|"
},
{
  title:"Time Management"
}

]

export const stackList1 = [
  
  
  
  
  
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
    name: "NodeJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
    name: "MongoDB",
  },
  {
    img: "https://mdarshadkhan.vercel.app/static/media/mongoose.51275a00.png",
    name: "Mongoose",
  },
  {
    img: "https://cdn.icon-icons.com/icons2/2699/PNG/512/expressjs_logo_icon_169185.png",
    name: "Express",
  },
  
  
 
  
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/git.svg",
    name: "Git",
  },
  {
    img: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
    name: "Postman",
  },
  
];
